import React, { useEffect, useState } from "react";

import Grid from "@material-ui/core/Grid";
import ReactPlayer from "react-player";

import Loading from "../../components/basics/Loading";

import { getPromoVideoBySubdomain } from "../../repositories/panel/v1/EntityRepository";

const Video = () => {
  const [loading, seLoading] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [allowedHosts] = useState([
    "portal",
    "portal1",
    "portal2",
    "portal3",
    "localhost:3000",
  ]);

  const [subdomain] = useState(
    localStorage.getItem("subdomain") ||
      window.location.host.substring(
        0,
        window.location.host.indexOf(".qyon.")
      ) ||
      window.location.host
  );

  useEffect(() => {
    (async () => {
      if (sessionStorage.getItem("promo_video_url")) {
        setVideoUrl(sessionStorage.getItem("promo_video_url"));
      } else {
        try {
          seLoading(true);
          if (allowedHosts.includes(subdomain)) {
            return;
          }

          const logoCallback = await getPromoVideoBySubdomain(subdomain);
          setVideoUrl(logoCallback?.data?.promo_video_url || "");

          sessionStorage.setItem(
            "promo_video_url",
            logoCallback?.data?.promo_video_url || ""
          );
        } catch (e) {
          console.error(e);
        } finally {
          seLoading(false);
        }
      }
    })();
  }, [allowedHosts, subdomain]);

  return (
    <>
      {loading ? (
        <Loading open={loading} />
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: "100vh" }}
        >
          <ReactPlayer url={videoUrl} controls={true} />
        </Grid>
      )}
    </>
  );
};

export default Video;
